export const buildItemClassName = (prefix, itemId) => {
  return `${prefix}-${itemId}`
}
